import { render, staticRenderFns } from "./FasilitatorList.vue?vue&type=template&id=30f22436"
import script from "./FasilitatorList.vue?vue&type=script&lang=js"
export * from "./FasilitatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports